// src/pages/AboutPage/AboutPage.jsx
import React from 'react';
import Cta from '../../components/sections/Cta/Cta';
import AboutUsPillars from '../../components/sections/AboutUsPillars/AboutUsPillars';
import Pricing from '../../components/sections/Pricing/Pricing';
const AboutPage = () => {
    return (
        <>
        <AboutUsPillars />
        <Pricing />
            <Cta />
        </>
    );
};

export default AboutPage;